import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const Author = styled.p`
	font-size: 1.4rem;
	font-weight: 400;
	line-height: 1;
	margin: 12px 0 0;
`;

export const Image = styled.img`
	max-width: 100%;
	width: 100%;
`;

export const StyledHeader = styled.div`
	padding-top: 16px;
	width: 100%;
`;

export const Title = styled.h1`
	font-size: 4.8rem;
	font-weight: 700;
	line-height: 1;
	margin: 40px 0 8px;

	${media.belowLarge`
		font-size: 3.2rem;
		line-height: 1.1875;
		margin: 32px 0 16px;
	`}
`;
